import EventTypeEvaluationPersonUpdated from './EventTypeEvaluations/PersonUpdated/PersonUpdated';
import EventTypeEvaluationBusinessUpdated from './EventTypeEvaluations/BusinessUpdated/BusinessUpdated';
import EventTypeEvaluationsExternalAccountCreated from './EventTypeEvaluations/ExternalAccountCreated/ExternalAccountCreated';
import EventTypeEvaluationTransaction from './EventTypeEvaluations/Transaction/Transaction';

export const DATA_SERVICES = {
  LexisNexisWorldCompliance: 'LexisNexis WorldCompliance',
  Socure30: 'Socure 30',
};

export const DISPLAY_STATUSES = ['webhook_pending', 'waiting'];

export const EVENT_TYPE_EVALUATION_MAPPING = {
  person_updated: EventTypeEvaluationPersonUpdated,
  external_account_created: EventTypeEvaluationsExternalAccountCreated,
  transaction: EventTypeEvaluationTransaction,
};

// a new mapping for use with the event-eval-improvements feature flag
// when the feature flag is removed, this should be rolled into the EVENT_TYPE_EVALUATION_MAPPING mapping above
export const IMPROVED_EVENT_EVALS_MAPPING = {
  business_updated: EventTypeEvaluationBusinessUpdated,
};
